import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Seguimiento/editarSeguimiento`, method: 'POST', body: values, token: token})
}
